<script setup lang="ts">
import AegPaginator from '@/app/shared/components/aeg-paginator/aeg-paginator.vue';
import type {PropType} from 'vue';
import {PagedResult} from '@/app/shared/helpers/paged-result.ts';
import {DocumentType, type Invoice, PaymentMethod} from '@/api/enterprise-gateway-api.proxy.ts';
import {useFormatting} from '@/composables/currency-format.ts';
import {useInvoicingStore} from '@/app/stores/invoicing-store.ts';
import {Button, Card} from 'primevue';

const props = defineProps({
    invoices: {type: Object as PropType<PagedResult<Invoice>>, default: () => PagedResult.createEmpty<Invoice>()},
});
const {formatCurrency, formatDate} = useFormatting();

const invoiceStore = useInvoicingStore();

const getDocumentTypeLabel = (documentType?: DocumentType): string => {
    return invoiceStore.getDocumentTypeLabel(documentType);
};
const isTopUpType = (documentType?: DocumentType): boolean => {
    return invoiceStore.isTopUpType(documentType);
};
const getInvoiceTypeIcon = (documentType?: DocumentType, paymentMethod?: PaymentMethod): string => {
    return invoiceStore.getInvoiceTypeIcon(documentType, paymentMethod);
};

</script>

<template>
    <div v-for="invoice in invoices.items" :key="invoice.invoiceNumber">
        <Card style="border-bottom: 1px solid var(--p-panel-header-border-color); border-radius:0; ">
            <template #title>
                <div style="font-size: 1rem;">
                    {{ formatDate(invoice.documentDate) }} - {{ invoice.invoiceNumber }}
                    <span v-if="invoice.customerReference">{{ invoice.customerReference }}</span>
                </div>
            </template>
            <template #subtitle>
                {{ getDocumentTypeLabel(invoice.documentType) }}
            </template>
            <template #content>
                <div style="display:flex; gap: 1rem; align-items: center; justify-content: space-between; flex-wrap: wrap;">
                    <div :class="{'aeg-invoices-details__topup': isTopUpType(invoice.documentType) }" style="font-weight: 700; flex-grow: 2">
                        <i :class="getInvoiceTypeIcon(invoice.documentType)" style="" />
                        &nbsp;
                        {{
                            isTopUpType(invoice.documentType) ? `+ ${formatCurrency(invoice.totalPrice)}` : formatCurrency(invoice.totalPrice)
                        }}
                    </div>
                    <div style="display:flex; gap: 1rem; ">
                        <Button
                            v-if="invoice.directPdfUrl"
                            as="a"
                            variant="outlined"
                            size="small"
                            icon="pi pi-file-pdf"
                            label="PDF"
                            aria-label="Download als pdf"
                            :href="invoice.directPdfUrl"
                        />
                        <Button
                            v-if="invoice.directCsvUrl"
                            as="a"
                            variant="outlined"
                            size="small"
                            icon="pi pi-file-excel"
                            label="CSV"
                            aria-label="Download als csv"
                            :href="invoice.directCsvUrl"
                        />
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<style scoped lang="scss">

</style>
